import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import LOOKUP from 'constants/lookup';
import { showError } from 'actions/CommonActions';
import { checkDateRange } from 'utils/helpers';
import { reportHourlySalesReport } from 'utils/breadcrumbInfo';
import CardSimple from 'screens/components/basic/CardSimple';
import Header from './Header';
import Pagination from 'screens/components/basic/Pagination';
import { getHourlySalesDateRange, getCsvReport } from 'actions/ReportsAction';
import { formInput, clearFormInput } from 'actions/FormActions';
import Grid from 'screens/components/basic/Grid';
import NoDataMsg from 'library/noData';
import PageHeader from 'screens/components/basic/PageHeader';
import {
    Table,
    TableBody,
    TableHead,
    TableCell,
    TableRow,
    TableFooter
} from '@mui/material';
import WithRouter from 'custom/withRouter';
import TableContainer from '@mui/material/TableContainer';

class HourlySalesDateRange extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activePage: 1,
            itemsPerPage: 20,
            showBody: false,
            totalRow: 0
        };
        this.showBody = this.showBody.bind(this)
    }

    componentWillMount() {
        const date = new Date();

        this.props.formInput(new Date(date.getFullYear(), date.getMonth(), 1), `HourlySalesDateRangeStartDate`);
        this.props.formInput(date, `HourlySalesDateRangeEndDate`);
    }

    getReport = () => {
        let branch = this.props.selectedBranch ? this.props.selectedBranch : this.props.loggedBranch;
        let startDate = this.props.startDate || moment().format("YYYY-MM-DD");
        let endDate = this.props.endDate || moment().format("YYYY-MM-DD");
        let pageNumber = this.state.activePage;
        let pageSize = this.state.itemsPerPage;
        this.props.getHourlySalesDateRange({ branch, startDate, endDate, pageNumber, pageSize });
    }

    downloadReport = () => {
        let branch = this.props.selectedBranch ? this.props.selectedBranch : this.props.loggedBranch;
        let startDate = this.props.startDate;
        let endDate = this.props.endDate;
        let pageNumber = 1;
        let pageSize = 9999;
        if (checkDateRange(startDate, endDate)) {
            this.props.showError(LOOKUP.report.common.dateRangeError);
        } else {
            this.props.getCsvReport(`reports/excel/hourlysalesdaterange?branchid=${branch}&startDate=${startDate}&endDate=${endDate}&pageNumber=${pageNumber}&pageSize=${pageSize}`, "HourlySalesDateRange");
        }
    }

    redirectToReport = () => {
        this.props.navigate("/report");
    }

    changePage = (e) => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: e
            };
        }, this.getReport);
    }

    filter = () => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getReport);
    }

    showBody() {
        if (checkDateRange(this.props.startDate, this.props.endDate)) {
            this.props.showError(LOOKUP.report.common.dateRangeError);
        } else {
            this.filter();
            this.setState({ showBody: true });
        }
    }

    rows = () => {
        if (!this.props.hourlySalesDateRange || !this.props.hourlySalesDateRange.list || this.props.hourlySalesDateRange.list.length == 0) return [];
        else {
            let colwidth = this.props.hourlySalesDateRange ? (78.0 / (this.props.hourlySalesDateRange.maxHour - this.props.hourlySalesDateRange.minHour + 1)).toFixed(1) + '%' : 0;
            let list = [];
            this.props.hourlySalesDateRange.list.map(item => {
                let data = [<TableCell style={{ width: `10%`, textAlign: `center`, whiteSpace: `unset` }}>{moment(item.date).format('ddd MMMM Do, YYYY')}</TableCell>];
                let i = this.props.hourlySalesDateRange.minHour;
                while (i <= this.props.hourlySalesDateRange.maxHour) {
                    let sales = item["hour" + i + "sales"];
                    let quantity = item["hour" + i + "quantity"];
                    data.push(<TableCell style={{ width: colwidth, textAlign: `center` }}>${sales}<br />({quantity})</TableCell>);
                    i++;
                }
                data.push(<TableCell style={{ width: `10%`, textAlign: `center` }}>${item.totalSales}<br />({item.totalQuantity})</TableCell>)
                list.push(data);
            });
            return list;
        }
    }

    columns = () => {
        let tableColumns = [""];
        if (!this.props.hourlySalesDateRange || !this.props.hourlySalesDateRange.list || this.props.hourlySalesDateRange.list.length == 0) return [];
        else {
            let i = this.props.hourlySalesDateRange.minHour;
            while (i <= this.props.hourlySalesDateRange.maxHour) {
                tableColumns.push(String(i))
                i++;
            }
            return tableColumns;
        }
    }

    render() {
        const totalRow = this.props.hourlySalesDateRange ? this.props.hourlySalesDateRange.total : 0;
        const colwidth = this.props.hourlySalesDateRange ? (80 / (this.props.hourlySalesDateRange.maxHour - this.props.hourlySalesDateRange.minHour + 1)).toFixed(2) + '%' : 0;

        return (
            <Grid headerContent={reportHourlySalesReport}>
                <PageHeader
                    title={LOOKUP.report.hourlySalesDateRange.text}
                    description={LOOKUP.report.hourlySalesDateRange.description}
                />
                <Header
                    branchOptions={this.props.brachOptions}
                    filter={this.filter}
                    download={this.downloadReport}
                    showBody={this.showBody}
                    loggedBranch={this.props.loggedBranch}
                />
                {
                    this.state.showBody &&
                    <CardSimple>
                        {
                            this.props.hourlySalesDateRange && this.props.hourlySalesDateRange.list && this.props.hourlySalesDateRange.list.length <= 0 ?
                                <NoDataMsg />
                                :
                                <div className="clearfix">
                                    <div className="text-center list_header">
                                        {this.props.startDate && this.props.endDate ?
                                            <p><i>Date Range:</i> <b>{moment(this.props.startDate).format('MMMM Do, YYYY')} - {moment(this.props.endDate).format('MMMM Do, YYYY')}</b></p>
                                            : ""}
                                    </div>
                                    <TableContainer>
                                    <div className="col-lg-12 mt-2 bg-light clearfix" displayRowCheckbox={false}>
                                        <Table className={`table-striped table-responsive`} style={{ fontSize: `10px` }} selectable={false} multiSelectable={false} >
                                            <TableHead className={`tableHeaderClass`} displaySelectAll={false} enableSelectAll={false}>
                                                <TableRow selectable={false}>{this.columns().map(item => { return (<TableCell style={{ whiteSpace: 'normal', width: colwidth, textAlign: `center` }}>{item}</TableCell>) })}<TableCell style={{ width: `10%`, textAlign: `center` }}>Total Sales<br />(Quantity)</TableCell></TableRow>
                                            </TableHead>
                                            <TableBody className={`tableBodyClass open-orders-table`} displayRowCheckbox={false}>
                                                {this.rows().map(item => (<TableRow className="table-row">{item}</TableRow>))}
                                            </TableBody>
                                        </Table>

                                    </div>
                                    </TableContainer>
                                    <Pagination
                                        length={totalRow}
                                        itemsPerPage={this.state.itemsPerPage}
                                        activePage={this.state.activePage}
                                        onPageChange={this.changePage}
                                    />
                                </div>
                        }
                    </CardSimple>
                }
            </Grid>
        )
    }
}

const mapStateToProps = state => {
    let branches = state.common.userBranches || [];
    let brachOptions = [];
    branches.map((item) => {
        brachOptions.push({
            text: item.name, value: item.id.toString()
        });
    })
    return {
        brachOptions: brachOptions,
        selectedBranch: state.form.HourlySalesDateRangeBranchOption,
        loggedBranch: state.common.branchId,
        startDate: moment(state.form.HourlySalesDateRangeStartDate).format("YYYY-MM-DD"),
        endDate: moment(state.form.HourlySalesDateRangeEndDate).format("YYYY-MM-DD"),
        hourlySalesDateRange: state.reports.hourlySalesDateRange
    };
};

const mapDispatchToProps = dispatch => {

    return {
        getHourlySalesDateRange: (model) => dispatch(getHourlySalesDateRange(model)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        showError: (message) => dispatch(showError(message)),
        formInput: (value, name) => dispatch(formInput(value, name)),
        getCsvReport: (url, name) => dispatch(getCsvReport(url, name))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(HourlySalesDateRange));
